export const config =
  import.meta.env.FLEET_FORMS_ENV === "production"
    ? // production
      {
        version: "yandex",
        passportURL:
          "https://passport.yandex." +
          window.location.hostname.split(".").at(-1),
      }
    : // testing
      {
        version: "yandex",
        passportURL:
          "https://passport-test.yandex." +
          window.location.hostname.split(".").at(-1),
      };
